import { motion } from "framer-motion"
import { useLanguage } from "../context/LanguageContext"
import { fadeUp, staggerContainer } from "../lib/motion"

const BenefitsSection = () => {
    const { translation: t, isRTL } = useLanguage()
    const { BenefitsSectionFeatures, BenefitsSectionTitle } = t


    const getImagePath = (imageName: string) => {
        if (imageName.startsWith('/')) {
            return imageName
        }
        return `/features/${imageName}`
    }

    return (
        <motion.div
            className='container mx-auto px-0 md:px-16 lg:px-24 xl:px-28'
            dir={isRTL ? "rtl" : "ltr"}
            variants={staggerContainer(0.12, 0.08)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
        >
            <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-9 md:gap-10 lg:gap-12 grid-flow-dense'>
                <motion.h2 className='flex justify-center items-center text-2xl md:text-3xl md:text-[2.5rem] font-bold text-primary text-center md:text-start px-6 md:px-12 !leading-tight' variants={fadeUp}>
                  {BenefitsSectionTitle}
                </motion.h2>
                {BenefitsSectionFeatures.map((benefit) => (
                    <motion.div
                        key={benefit.id}
                        className='flex flex-col items-center justify-start w-[18.75rem] mx-auto hover-lift'
                        variants={fadeUp}
                        whileHover={{ y: -6, scale: 1.02 }}
                    >
                        {benefit.image && (
                            <img src={getImagePath(benefit.image)} alt={benefit.title} className='w-64 h-48 hover-scale' />
                        )}
                        <h3 className='text-base lg:text-[1.375rem] font-bold text-blackTwo text-center mt-3 px-3.5 leading-[130%] lg:!leading-[1.875rem]'>{benefit.title}</h3>
                        <p className='text-base lg:text-[1.375rem] text-blackTwo text-center leading-[130%] lg:!leading-[1.875rem]'>{benefit.description}</p>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    )
}

export default BenefitsSection